import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=2cb0e6ae&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&id=2cb0e6ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb0e6ae",
  null
  
)

export default component.exports